import Model from "./base/model";

class QuotationDocument extends Model{
  resourceName() {
    return "quotation_documents";
  }

  fields() {
    return {
      name: "",
      path: "",
      type: "",
      verification: "",
      updated_at: "",
      observation_to_banks: "",
      verification_integra: "",
      quotation_extra_document_id: "",
      bank_to_taker_observation: "",
      transporter_document_id: "",
    }
  }

  async updateObservation(data) {
    return this.request(
      "document_observation/" + data.id,
      "POST",
      {},
      data
    );
  }
}

export default new QuotationDocument();
